const URLTC = {
    getInfo: {//个人信息  
		url: '/auth/sysUser/info',
		params: {}
	},
    changeInfo: {//修改个人信息  
		url: '/auth/sysUser/cus-info',
		params: {}
	},
    getOrders: {//我的订单 
		url: '/front/order/orders',
		params: {}
	},
    getStaffs: {//查询客户的经纪人下拉选
		url: '/auth/staffs/list',
		params: {}
	},
    getStaffsInfo: {//查询客户的经纪人 信息
		url: '/auth/staffs/card',
		params: {}
	},

}
export default URLTC;